import { ENDPOINTS, HOSTS } from "@/constants";
import {
  ADD_AUTOCPERAPPORT,
  ADD_AUTOCPERAPPORT_FAILURE,
  ADD_AUTOCPERAPPORT_SUCCESS,
  DELETE_AUTOCPERAPPORT,
  DELETE_AUTOCPERAPPORT_FAILURE,
  DELETE_AUTOCPERAPPORT_SUCCESS,
  LOAD_AUTOCPERAPPORT,
  LOAD_AUTOCPERAPPORT_FAILURE,
  LOAD_AUTOCPERAPPORT_SUCCESS,
  LOAD_AUTOCPERAPPORTS,
  LOAD_AUTOCPERAPPORTS_FAILURE,
  LOAD_AUTOCPERAPPORTS_HISTORY,
  LOAD_AUTOCPERAPPORTS_HISTORY_FAILURE,
  LOAD_AUTOCPERAPPORTS_HISTORY_SUCCESS,
  LOAD_AUTOCPERAPPORTS_SUCCESS,
  UPDATE_AUTOCPERAPPORT,
  UPDATE_AUTOCPERAPPORT_FAILURE,
  UPDATE_AUTOCPERAPPORT_SUCCESS,
} from "./mutations";
import type { ActionTree } from "vuex";
import type { RootState } from "@/types";
import { type AxiosResponse, httpClient } from "@/services/httpClient";
import type { CpeRapportListState } from "@/types/store";
import type { CpeRapport } from "@/types/cpe";

export const actions: ActionTree<CpeRapportListState, RootState> = {
  fetchAutoCperapports({ commit }, params: any) {
    commit(LOAD_AUTOCPERAPPORTS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTSAUTO}`, { params })
      .then(
        (response: AxiosResponse<CpeRapport[]>) => {
          commit(LOAD_AUTOCPERAPPORTS_SUCCESS, response);
        },
        (error) => {
          commit(LOAD_AUTOCPERAPPORTS_FAILURE, error.message);
        },
      );
  },
  fetchAutoCperapportsHistory({ commit }, params: any) {
    commit(LOAD_AUTOCPERAPPORTS_HISTORY);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTSAUTO}/sent`, { params })
      .then(
        (response: AxiosResponse<CpeRapport[]>) => {
          commit(LOAD_AUTOCPERAPPORTS_HISTORY_SUCCESS, response);
        },
        (error) => {
          commit(LOAD_AUTOCPERAPPORTS_HISTORY_FAILURE, error.message);
        },
      );
  },
  addAutoCperapport({ commit }, cperapport: any) {
    return new Promise((resolve, reject) => {
      commit(ADD_AUTOCPERAPPORT);
      httpClient
        .post(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTSAUTO}`, {
          ...cperapport,
        })
        .then(
          (response: AxiosResponse<any>) => {
            if (response) {
              commit(ADD_AUTOCPERAPPORT_SUCCESS, response.data);
              resolve(response.data);
            } else {
              commit(ADD_AUTOCPERAPPORT_FAILURE, "response undefind");
              reject("response undefind");
            }
          },
          (error) => {
            commit(ADD_AUTOCPERAPPORT_FAILURE, error.message);
            reject(error);
          },
        );
    });
  },
  updateAutoCperapport({ commit }, cperapport: any) {
    commit(UPDATE_AUTOCPERAPPORT);
    httpClient
      .put(
        `${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTSAUTO}/${cperapport.id}`,
        cperapport,
      )
      .then(
        (response: AxiosResponse<any>) => {
          commit(UPDATE_AUTOCPERAPPORT_SUCCESS, response.data);
        },
        (error) => {
          commit(UPDATE_AUTOCPERAPPORT_FAILURE, error.message);
        },
      );
  },

  // LOAD_ONE_AUTOCPERAPPORT
  fetchAutoCperapport({ commit }, id: any) {
    commit(LOAD_AUTOCPERAPPORT);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTSAUTO}/${id}`).then(
      (response: AxiosResponse<any>) => {
        commit(LOAD_AUTOCPERAPPORT_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_AUTOCPERAPPORT_FAILURE, error.message);
      },
    );
  },

  deleteAutoRapport({ commit }, repportId: any) {
    commit(DELETE_AUTOCPERAPPORT);
    httpClient
      .delete(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTSAUTO}/${repportId}`)
      .then(
        () => {
          commit(DELETE_AUTOCPERAPPORT_SUCCESS, repportId);
        },
        (error) => {
          commit(DELETE_AUTOCPERAPPORT_FAILURE, error.message);
        },
      );
  },
};
